module.exports = __webpack_public_path__ + "static/media/card6.47851c7e.png";